export const ContractNotificationConstants = {
  type: {
    PROD_EMAIL: 'productionEmail',
    ADMIN_EMAIL: 'adminEmail',
    QA_EMAIL: 'qaEmail'
  }
};

export default ContractNotificationConstants;
